import { escapeRegex } from "@/lib/format";

/** Splits text into segments and wraps occurrences of `query` in <mark>.
 *  Returns an array suitable for direct rendering — the React side handles
 *  escaping. */
export function highlightMatch(text: string, query: string): React.ReactNode {
  const safe = String(text ?? "");
  const q = String(query ?? "").trim();
  if (!q) return safe;
  const re = new RegExp(`(${escapeRegex(q)})`, "giu");
  const parts = safe.split(re);
  // String.split with a capturing group alternates non-match (even index)
  // and match (odd index) segments — wrap odd-indexed parts in <mark>.
  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <mark key={i} className="rounded bg-primary/30 px-0.5 text-foreground">
        {part}
      </mark>
    ) : (
      <span key={i}>{part}</span>
    ),
  );
}
